// 工作台接口
import axios from "@/axios";
import { baseUrl } from "@/axios/baseUrl";

// 获取今日登录操作次数统计
export const getTodayOperationStatistics = () =>
  axios.get(baseUrl + "/api/smart-workbench/today-operation-statistics");

// 获取近期操作日志
export const getRecentOperationLog = () =>
  axios.get(baseUrl + "/api/smart-workbench/recent-operation-log");

// 获取操作日志分页
export const getOperationLogPage = (data) =>
  axios.post(baseUrl + "/api/smart-workbench/operation-log/page", data);
